<template>
  <div class="selection-summary" v-if="selectedItems.length > 0" @click="$emit('continue-clicked')">
    <div class="summary-container">
      <!-- Selected capability tags -->
      <div class="selected-tags mb-2">
        <span 
          v-for="(item, index) in selectedCapabilities" 
          :key="index"
          class="capability-tag"
          :style="{ backgroundColor: item.color }"
        >
          {{ item.label }}
        </span>
      </div>
      
      <div class="continue-button mt-3">
        <span class="continue-text">Continue with {{ selectedItems.length }} of {{ totalItems }} capabilities selected</span>
        <span class="continue-arrow">→</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelectionSummary',
  
  props: {
    selectedItems: {
      type: Array,
      default: () => []
    },
    allItems: {
      type: Array,
      default: () => []
    }
  },
  
  computed: {
    totalItems() {
      return this.allItems.length;
    },
    
    selectedCapabilities() {
      return this.selectedItems.map(index => {
        const item = this.allItems[index];
        if (!item) return { label: 'Unknown', color: '#3F95C8' };
        
        return {
          label: item.label || item.name || 'Unknown',
          color: item.group !== undefined ? ['#7A3C9A', '#3DB09E', '#3F95C8'][item.group] || '#3F95C8' : '#3F95C8'
        };
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.selection-summary {
  margin-top: 1.5rem;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  cursor: pointer;
  
  .summary-container {
    padding: 1rem;
    background-color: #e8f4f8;
    border-radius: 8px;
    text-align: center;
    transition: all 0.3s ease;
    
    &:hover {
      background-color: #d4e8f0;
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }
  }
  
  .selected-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    justify-content: center;
    
    .capability-tag {
      color: white;
      padding: 0.25rem 0.75rem;
      border-radius: 16px;
      font-weight: 600;
      font-size: 0.875rem;
      white-space: nowrap;
    }
  }
  
  .continue-button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    
    .continue-text {
      color: #00bcd4;
      font-weight: 700;
      font-size: 0.9rem;
      letter-spacing: 0.5px;
    }
    
    .continue-arrow {
      color: #00bcd4;
      font-weight: bold;
      font-size: 1.2rem;
    }
  }
}
</style>
